import { render, staticRenderFns } from "./workflow_form_model_edit.vue?vue&type=template&id=0460ad31&scoped=true"
import script from "./workflow_form_model_edit.vue?vue&type=script&lang=js"
export * from "./workflow_form_model_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460ad31",
  null
  
)

export default component.exports